import React from 'react'
import { format, startOfDay } from 'date-fns'
import { map, identity, times } from 'ramda'

const TimeSelectOptions = () => {
  let startOfDayDate = startOfDay(new Date())
  let timeSlices = map(
    index => {
      const minutes = index * 15
      const date = new Date(startOfDayDate.getTime() + minutes * 60000)
      return format(date, 'h:mm aaa')
    },
    times(identity, 24 * 4)
  )

  return timeSlices.map(time => (
    <option key={time} value={time}>
      {time}
    </option>
  ))
}

export default TimeSelectOptions
